export default [
  { url: '/user/shop/mapping', method: 'put' },
  { url: '/user/shop', method: 'put' },
  { url: '/privilege/mapping', method: 'put' },
  { url: '/user/scene', method: 'put' },
  { url: '/vip/renew/mode', method: 'put' },
  { url: '/pay/type', method: 'put' },
]